(()=>{'use strict';
const offers={'1':59292084470108,'3':59292093481308,bundle:59292243951964};
const root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
let adding=false;
const variant=new URLSearchParams(location.search).get('variant');
const initial=Object.keys(offers).find(k=>String(offers[k])===variant)||(location.pathname.includes('walko-pack-bebe-3-pots-2-brosses')?'bundle':null);
if(initial){const option=document.querySelector('input[name="baby-pack"][value="'+initial+'"]');if(option){option.checked=true;option.dispatchEvent(new Event('change',{bubbles:true}));}}
document.querySelectorAll('[data-baby-add]').forEach(button=>button.addEventListener('click',async()=>{
 const selected=document.querySelector('input[name="baby-pack"]:checked');
 if(!selected||!offers[selected.value]||button.disabled||adding)return;
 const message=document.querySelector('[data-baby-error]');
 adding=true;document.querySelectorAll('[data-baby-add]').forEach(b=>b.disabled=true);button.setAttribute('aria-busy','true');
 const label=button.textContent;button.textContent='Ajout en cours…';if(message)message.textContent='';
 try{
  const response=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:offers[selected.value],quantity:1}]})});
  const data=await response.json();
  if(!response.ok)throw new Error(data.description||'Impossible d’ajouter cette offre. Réessayez.');
  location.assign(root+'cart');
 }catch(error){if(message){message.textContent=error.message;message.scrollIntoView({block:'center'});}adding=false;document.querySelectorAll('[data-baby-add]').forEach(b=>b.disabled=false);button.removeAttribute('aria-busy');button.textContent=label;}
}));
})();
